import { Tooltip } from "recharts";
import { fmtValue } from "../utils/PerformanceUtils";

const T = Tooltip as any;
const ChartTooltip = () => (
  <T
    contentStyle={{
      background: "#ffffff",
      border: "none",
      borderRadius: 8,
      color: "#f1f5f9",
      fontSize: 12,
      padding: "8px 12px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
    }}
    formatter={(v: unknown, name: unknown) => [fmtValue(v), name]}
    labelStyle={{ color: "#94a3b8", marginBottom: 4 }}
  />
);

export default ChartTooltip;